const gateway_states = state => state.gateway_states
const gateway_state = state => state.gateway_state
const gateway_list_view = state => state.gateway_list_view
const gateway_revisions = state => state.gateway_revisions
const gateway_revisions_view = state => state.gateway_revisions_view
const profile_revisions = state => state.profile_revisions
const profile_revisions_view = state => state.profile_revisions_view
const spectral_scan = state => state.spectral_scan
const spectral_scan_view = state => state.spectral_scan_view

export default {
  gateway_states,
  gateway_state,
  gateway_list_view,
  gateway_revisions,
  gateway_revisions_view,
  profile_revisions,
  profile_revisions_view,
  spectral_scan,
  spectral_scan_view
}



// WEBPACK FOOTER //
// ./src/modules/gatewayStates/store/getters.js